import type { AdminNavItem, AdminSurfaceConfig } from '../surface';

interface PlaceholderPageProps {
  item: AdminNavItem;
  surfaceConfig: AdminSurfaceConfig;
}

export default function PlaceholderPage({ item, surfaceConfig }: PlaceholderPageProps) {
  const Icon = item.icon;

  return (
    <div className="page-stack">
      <section className="page-heading">
        <div>
          <p className="section-eyebrow">{surfaceConfig.shortTitle}</p>
          <h2>{item.label}</h2>
          <p>{item.description} 화면은 Cloudflare Worker API 계약에 따라 연결됩니다.</p>
        </div>
        <Icon size={30} />
      </section>
    </div>
  );
}
